import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import { APPLICANT_TYPES } from '../../util/constants';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import BusinessEinForm from '../../components/Forms/BusinessEinForm';
import themeColors from '../../assets/styles/themeColors';

const VerifyBusinessEin = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const formId = 'businessEin_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
      eventType={eventType}
    >
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('verifyBusinessEin.title')}
      </HeadingSubtitle>
      <BusinessEinForm
        applicantType={APPLICANT_TYPES.BUSINESS}
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default VerifyBusinessEin;
